/* eslint-disable quote-props, no-dupe-keys, max-len */
const style = () => ({
    position: 'relative',
    overflow: 'hidden',
    margin: 0
})

export default style
